import Route from '@ember/routing/route';

export default class MarketSettingsPropertyTagsCustomRoute extends Route {}
